export const referralCodeFormConstant = {
  ReferralCode: 'referralCode',
};
